import _Layout from './Layout';
import _LayoutItem from './LayoutItem';

export const Layout = _Layout;
export const LayoutItem = _LayoutItem;



/** WEBPACK FOOTER **
 ** ./web/js/components/Layout/index.js
 **/